import React, { useEffect, useState } from 'react';
import ReactTable from 'react-table';
import { filterCaseInsensitive } from "../../services/helpers/table";

const AdminInventoryTable = props => {
    const columns = [{
        Header: 'SKU',
        accessor: 'sku',
    },{
        Header: 'JUMLAH',
        accessor: 'quantity',
        Cell: ({row,original}) => qtyCell(original)
    }];

    const qtyCell = (og) => {
        return (
            <div>
                <b>{og.quantity}</b><br/>
            </div>
        )
    };

    return (
        <div>
            <ReactTable
                data={props.data}
                columns={columns}
                defaultPageSize={10}
                filterable
                defaultFilterMethod={filterCaseInsensitive}
                loading={props.loading}
                className="-striped -highlight"
            />
        </div>
    )
};

export default AdminInventoryTable;